package one.healthium.pilates.presentation.navigation.main

import co.touchlab.kermit.Logger
import kotlinx.coroutines.flow.catch
import kotlinx.coroutines.flow.collect
import kotlinx.coroutines.flow.onEach
import one.healthium.domain.user.UserInteractor
import one.healthium.domain.user.models.SubscriptionStatus
import one.healthium.intercom.IntercomPlatform
import one.healthium.ui.common.vm.BaseViewModel

class MainViewModel(
    private val userInteractor: UserInteractor,
) : BaseViewModel() {
    init {
        launch {
            userInteractor.syncHealthData()
                .catch { Logger.e("Error syncing health data", it) }
                .collect {
                    Logger.d("Health data synced")
                }
        }
        launch {
            userInteractor.updateSystemData()
                .catch { Logger.e("Error syncing health data", it) }
                .collect {
                    Logger.d("System data updated")
                }
        }
        launch {
            userInteractor.observeUser()
                .onEach { user ->
                    try {
                        if (user.purchases.subscription == SubscriptionStatus.Active) {
                            IntercomPlatform.boot()
                        } else {
                            IntercomPlatform.shutdown()
                        }
                    } catch (e: Exception) {
                        Logger.e("Error updating Intercom", e)
                    }
                }
                .collect()
        }
    }
}